import moment from 'moment-timezone';

// The Backend language is PHP which works with seconds instead of milliseconds.
// JavaScript Date objects represent a single moment in time in a platform-independent format. Date objects contain a Number that represents milliseconds since 1 January 1970 UTC.
// @see https://stackoverflow.com/questions/847185/convert-a-unix-timestamp-to-time-in-javascript
// We need to avoid decimals
export const toBackend = (date: moment.Moment) => date.clone().set({ second: 0 }).unix();

export const toBackendWithTimezone = (date: moment.Moment, timezone: string, keepLocalTime: boolean) =>
  date.clone().tz(timezone, keepLocalTime).unix();

export const formatTimeToBackend = (date: moment.Moment, time: string, timezone: string): number => {
  const hourAndMinute = time.split(':');
  const momentCopy = date.clone().tz(timezone);

  if (hourAndMinute[0] && hourAndMinute[1]) {
    momentCopy.set({
      hour: Number(hourAndMinute[0]) || 0,
      minute: Number(hourAndMinute[1]) || 0,
      second: 0,
    });
  }
  return momentCopy.unix();
};
